export function toTimeseriesNumeric(value) {
  if (value == null || !String(value).trim()) return null;
  const text = String(value).replace(/[^\d.-]/g, "");
  if (!text) return null;
  const number = Number(text);
  return Number.isFinite(number) ? number : null;
}

export function buildSingleMetricChartData(
  sortedFiles,
  { label, getValue, borderColor, backgroundColor, excludeMissing = false },
) {
  const chartFiles = excludeMissing
    ? sortedFiles.filter((item) => getValue(item) != null)
    : sortedFiles;
  return {
    labels: chartFiles.map((item) =>
      String(item?.shooting_date || item?.uploaded_at || item?.file_name || "-").trim(),
    ),
    datasets: [{
      label,
      data: chartFiles.map((item) => getValue(item)),
      borderColor,
      backgroundColor,
      tension: 0.25,
      spanGaps: true,
    }],
  };
}

export function buildChartOptions() {
  return {
    responsive: true,
    maintainAspectRatio: false,
    interaction: { mode: "index", intersect: false },
    plugins: { legend: { display: false } },
    scales: {
      x: { grid: { color: "#e5e7eb" } },
      y: { grid: { color: "#e5e7eb" } },
    },
  };
}
